import InputLabel from '@material-ui/core/InputLabel'
import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
`

export const Label = styled(InputLabel)`
  margin-bottom: 8px;
`
